import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
// import { environment } from './environment';

import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';

import { Account } from './account';
import { IGenericType } from '@library/common/generictype';

@Injectable({
   providedIn: 'root'
})
export class AccountService {
   error: string;

   get account(): Account {
      const a = sessionStorage.getItem( 'accountInfo' );
      if ( !a ) { return; }

      return new Account( JSON.parse( a ));
   }
   set account( value ) {
      sessionStorage.setItem( 'accountInfo', JSON.stringify( value ));
      if ( !value ) { sessionStorage.removeItem( 'accountInfo' ); }
   }

   get number() { return sessionStorage.getItem( 'account' ) ? +sessionStorage.getItem( 'account' ) : null; }
   set number( value ) { sessionStorage.setItem( 'account', value?.toString() ); }

   // Kept as a string (not coerced with +) so 7-digit override pins with a leading
   // zero (e.g. "0544971") survive intact through to the API request.
   get pin(): string | null { return sessionStorage.getItem( 'pin' ) || null; }
   set pin( value: string | number | null ) {
      if ( value === null || value === undefined || value === '' ) {
         sessionStorage.removeItem( 'pin' );
         return;
      }
      sessionStorage.setItem( 'pin', String( value ) );
   }

   constructor(
      private http: HttpClient,
   ) { }

   verifyAccount(): Observable<Account> {
      this.account = null;
      this.error = null;

      return this.http.post<IGenericType>( 'account', { account: this.number, pin: this.pin }, { params: { useLambda: true } })
         .pipe(
            map( a => new Account({ ...a.response, number: this.number })),
            tap( account => this.account = account ),
            catchError( err => {
               this.error = err?.error?.messages[0].message ?? 'This system is unavailable at this time, please try again later';

               throw err;
            }),
         );
   }

   reset() {
      sessionStorage.clear();
   }
}
